import {
  faCouch,
  faHouseChimneyCrack,
  faKey,
  faPersonRunning,
  faSkull,
} from '@fortawesome/pro-duotone-svg-icons'

import { NotFoundCopyVariant } from './types'

const VARIANTS: NotFoundCopyVariant[] = [
  {
    icon: faHouseChimneyCrack,
    heading: "This place doesn't exist",
    subheading:
      "Either it was rented out, demolished, or it was never here. Either way, let's get you home.",
  },
  {
    icon: faKey,
    heading: 'No keys for this door',
    subheading:
      "The address you typed isn't one we know. Hit Home and let's try a different unit.",
  },
  {
    icon: faPersonRunning,
    heading: "You've wandered off the map",
    subheading:
      "Cool spot, but it's not part of QuickPass. Let's walk you back to the dashboard.",
  },
  {
    icon: faSkull,
    heading: 'Dead-end lease',
    subheading:
      'This URL leads nowhere — like a basement studio listed at $4,500. Avoid avoid avoid.',
  },
  {
    icon: faCouch,
    heading: 'Empty room',
    subheading:
      "There's nothing on this page yet. Maybe a future feature? For now, your dashboard is one click away.",
  },
]

/**
 * Picks a random copy variant for the not-found page so refreshes feel
 * different. Pure for a given seed; deterministic helper makes it easy
 * to test without flaking.
 *
 * @param {number} seed - the millis timestamp used to pick a variant
 * @returns {NotFoundCopyVariant} one of the curated copy variants
 */
const pickNotFoundCopy = (seed: number): NotFoundCopyVariant => {
  const index = Math.abs(seed) % VARIANTS.length
  return VARIANTS[index]
}

export { pickNotFoundCopy }
